import { TrendingUp, TrendingDown, ArrowRight } from 'lucide-react';
import styles from './InsightCard.module.css';

/**
 * InsightCard Component
 * Displays top performer insights with metrics and action button
 */
function InsightCard({
    title,
    icon: Icon,
    primaryLabel,
    primaryValue,
    secondaryStats = [],
    trendPercent = null,
    trendDirection = null,
    onViewDetails = null,
    viewDetailsLabel = 'View Orders',
    color = 'primary',
    compact = false,
}) {
    // Determine trend direction from value if not provided
    const direction = trendDirection || (trendPercent > 0 ? 'up' : trendPercent < 0 ? 'down' : 'neutral');
    const TrendIcon = direction === 'up' ? TrendingUp : direction === 'down' ? TrendingDown : null;

    return (
        <div className={`${styles.insightCard} ${compact ? styles.compact : ''}`}>
            <div className={styles.header}>
                {Icon && (
                    <div className={`${styles.iconWrapper} ${styles[color]}`}>
                        <Icon size={compact ? 16 : 20} />
                    </div>
                )}
                <span className={styles.title}>{title}</span>
            </div>

            <div className={styles.primaryContent}>
                <span className={styles.primaryLabel}>{primaryLabel}</span>
                <h3 className={styles.primaryValue}>{primaryValue}</h3>
            </div>

            {secondaryStats.length > 0 && (
                <div className={styles.secondaryStats}>
                    {secondaryStats.map((stat, index) => (
                        <div key={index} className={styles.stat}>
                            <span className={styles.statLabel}>{stat.label}</span>
                            <span className={styles.statValue}>{stat.value}</span>
                        </div>
                    ))}
                </div>
            )}

            <div className={styles.footer}>
                {trendPercent !== null && (
                    <div className={`${styles.trend} ${styles[direction]}`}>
                        {TrendIcon && <TrendIcon size={14} />}
                        <span>{Math.abs(trendPercent).toFixed(1)}%</span>
                    </div>
                )}

                {onViewDetails && (
                    <button className={styles.viewButton} onClick={onViewDetails}>
                        {viewDetailsLabel}
                        <ArrowRight size={14} />
                    </button>
                )}
            </div>
        </div>
    );
}

export default InsightCard;
